import AbstractProvider from '../App/AbstractProvider';
import {IDatabase} from '../../@interfaces/services/Database';
import {IFormConfig} from '../../@interfaces/components/Form/IFormConfig';
import {StringArray} from '../../@interfaces/types';
import {IForms} from '../../@interfaces/services/Forms/IForms';
import {fetchFormsConfigs, setFormsConfigs} from '../../_redux/forms/actions';
import {IStoreEvents} from '../../@interfaces/services/StoreEvents/IStoreEvents';
import {FORMS_SET_CONFIGS} from '../../_redux/forms/constants';
import FormConfig from '../Database/Models/FormConfig';

export default class FormsProvider extends AbstractProvider {
	async boot(): Promise<void> {
		this.subscribeToStoreEvents();

		if (!this.app.config.get('client.store-data-in-db') as boolean) {
			return;
		}

		const table = this.getStoredService<IDatabase>('db').formsConfigs;
		if (!table) {
			return;
		}

		const configs = await table.toArray().then(configs => {
			return configs.reduce((res: StringArray<IFormConfig>, config) => {
				res[config.name] = config.config;

				return res;
			}, {});
		});

		this.app.dispatchAction(setFormsConfigs(configs));
	}

	async loading(): Promise<void> {
		if (Object.keys(this.getStoredService<IForms>('forms').getFormsConfigs() || {}).length <= 0) {
			this.app.dispatchAction(fetchFormsConfigs());
		}
	}

	protected subscribeToStoreEvents() {
		const dispatcher = this.getStoredService<IStoreEvents>('store-events');

		dispatcher.listen(FORMS_SET_CONFIGS, (e, payload) => {
			const configs: StringArray<IFormConfig> = payload.action.payload;

			const records = Object.keys(configs).reduce((res: any[], name) => {
				res.push([{name}, {config: configs[name]}]);

				return res;
			}, []);

			this.getStoredService<IForms>('forms').setFormsConfigs(configs);

			return FormConfig.updateOrCreateMany<FormConfig>(records);
		});
	}
}
